export function hasPermission(admin, moduleName, action = "read") {
  const permissions = (admin && admin.permissions) || [];
  return Boolean(admin && (admin.role_code === "super_admin" || permissions.includes("*:*") || permissions.includes(`${moduleName}:manage`) || permissions.includes(`${moduleName}:${action}`)));
}

export const navigationGroups = [
  { key: "business", label: "业务办理", icon: "el-icon-s-order", items: [
    { path: "/business/consultations", label: "咨询接待", icon: "el-icon-chat-dot-round", modules: ["consultations"] },
    { path: "/business/records", label: "需求与订单", icon: "el-icon-tickets", modules: ["custom-demands", "service-orders", "consult-orders"] },
    { path: "/customers/users", label: "客户管理", icon: "el-icon-user", modules: ["users"] },
    { path: "/business/reviews", label: "评价审核", icon: "el-icon-chat-line-square", modules: ["reviews"] }
  ] },
  { key: "products", label: "产品库", icon: "el-icon-map-location", items: [
    { path: "/content/routes", label: "线路产品", icon: "el-icon-map-location", modules: ["routes"] },
    { path: "/content/route-plans", label: "方案模板", icon: "el-icon-tickets", modules: ["route-plans"] },
    { path: "/content/scenic", label: "景点与地图", icon: "el-icon-location-outline", modules: ["scenic-spots", "scenic-map-points"] },
    { path: "/content/hotels", label: "酒店管理", icon: "el-icon-office-building", modules: ["hotels"] },
    { path: "/content/foods", label: "美食推荐", icon: "el-icon-dish", modules: ["food-items"] },
    { path: "/content/culture", label: "文化体验", icon: "el-icon-school", modules: ["culture-experiences"] }
  ] },
  { key: "operations", label: "小程序装修", icon: "el-icon-monitor", items: [
    { path: "/content/home", label: "首页与登录页", icon: "el-icon-house", modules: ["home-configs"] },
    { path: "/content/featured", label: "精选行程", icon: "el-icon-star-off", modules: ["routes", "settings"] },
    { path: "/inspirations", label: "灵感探索", icon: "el-icon-collection", modules: ["inspiration-items"] },
    { path: "/content/services", label: "服务介绍", icon: "el-icon-service", modules: ["basic-service-config", "custom-service-config", "service-need-options"] },
    { path: "/content/about", label: "关于我们与页面图片", icon: "el-icon-picture", modules: ["settings"] }
  ] },
  { key: "finance", label: "财务与渠道", icon: "el-icon-bank-card", items: [
    { path: "/business/payments", label: "支付记录", icon: "el-icon-bank-card", modules: ["payments"] },
    { path: "/business/recommenders", label: "推荐官", icon: "el-icon-share", modules: ["recommenders", "settings"] }
  ] },
  { key: "system", label: "系统设置", icon: "el-icon-setting", items: [
    { path: "/system/roles", label: "角色与菜单权限", icon: "el-icon-lock", modules: ["roles"] },
    { path: "/team/staff", label: "员工账号", icon: "el-icon-user-solid", modules: ["staff"] },
    { path: "/system/agreements", label: "协议管理", icon: "el-icon-document-checked", modules: ["agreement-versions"] },
    { path: "/system/settings", label: "系统参数", icon: "el-icon-setting", modules: ["settings"] },
    { path: "/system/proposal", label: "定制方案配置", icon: "el-icon-notebook-2", modules: ["settings"] },
    { path: "/content/assets", label: "图片素材库", icon: "el-icon-picture-outline", modules: ["assets"] }
  ] }
];

export function visibleNavigation(admin) {
  return navigationGroups.map(group => ({ ...group, items: group.items.filter(item => item.modules.some(moduleName => hasPermission(admin, moduleName))) })).filter(group => group.items.length);
}

export function navigationForPath(path) {
  for (const group of navigationGroups) {
    const item = group.items.find(item => item.path === path);
    if (item) return { group, item };
  }
  return null;
}
